module.exports = __webpack_public_path__ + "static/media/bg-5.6c9f4b05.png";